module.exports = __webpack_public_path__ + "img/testPhone_c.fe2e560f.png";